import React from 'react'
import DocumentTitle from 'react-document-title'
import Header from './Header'

export default class MasterPage extends React.Component {
  render() {
    return (
      <DocumentTitle title={'Café App'}>
        <div className='MasterPage'>
          <Header location={this.props.location}/>
          { this.props.children }
        </div>
      </DocumentTitle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/MasterPage.js